// @ts-nocheck
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import {
    chain,
    DispatchBeginLoadCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";
import constants from "@store/constants";
import { ExtractHandlerParameter, ExtractHandlerProps } from "@store/Framework/Types/Common";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerChainType = typeof DispatchBeginLoadCart;

export interface LoadCurrentCartParameter extends ExtractHandlerParameter<HandlerChainType> {
    shouldTriggerSoftSubmit?: boolean;
}

export interface LoadCurrentCartProps extends ExtractHandlerProps<HandlerChainType> {}

replaceInChain<LoadCurrentCartParameter, LoadCurrentCartProps>(chain, DispatchBeginLoadCart, async props => {
    const state = props.getState();
    /* Store Custom Code - Start */
    const pageType = getCurrentPage(state).type;
    const isNotReviewAndSubmitPage = pageType !== constants.pageType.checkoutReviewAndSubmit;
    /* Store Custom Code - End */

    if (getCurrentCartState(state).isLoading && isNotReviewAndSubmitPage /* Store Custom Code */) {
        return false;
    }

    props.dispatch({
        type: "Data/Carts/BeginLoadCart",
        id: API_URL_CURRENT_FRAGMENT,
    });

    if (props.parameter.shouldLoadFullCart !== false) {
        await waitFor(() => getCurrentPage(props.getState()) !== nullPage);
    }
});

addToChainAfter<LoadCurrentCartParameter, LoadCurrentCartProps>(chain, PopulateApiParameter, props => {
    const pageType = getCurrentPage(props.getState()).type;
    const expandWithoutTax = props.apiParameter.expand?.filter(x => x !== "tax");

    if (pageType !== constants.pageType.checkoutReviewAndSubmit) {
        props.apiParameter.expand = expandWithoutTax;
    } else {
        props.apiParameter.additionalQueryStringParameters = {
            ...props.apiParameter.additionalQueryStringParameters,
            timestamp: Date.now(),
        };
    }

    if (props.parameter.shouldTriggerSoftSubmit) {
        props.apiParameter.shouldTriggerSoftSubmit = true;
    }
});
